// extracted by mini-css-extract-plugin
export default {"container":"CategoryList_container__4QO+E","category":"CategoryList_category__l+dsL","active":"CategoryList_active__rtzLQ"};